import React from 'react';
export default () =>
	<svg width="50px" height="50px" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 50 50">
		<defs>
			<style>{`.cls-1{fill:#313130;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:1.44351px;}`}</style>
			<symbol id="Grey_Arrow" dataName="Grey Arrow" viewBox="0 0 23 23">
				<circle className="cls-1" cx="11.5" cy="11.5" r="11.5"/>
				<polyline className="cls-2" points="8.948 6.396 14.052 11.5 8.948 16.604"/>
			</symbol>
		</defs>
		<title>GLE12487_Website_Icons</title>
		<use width="35" height="35" transform="translate(13 13)" xlinkHref="#Grey_Arrow"/>
	</svg>


// WEBPACK FOOTER //
// ./src/svg/left-arrow-circle.js